"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import SectionTitle from "@/components/common/section-title";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

              <EspaceProTitleCard title={"Devenir Partenaire"}
                                  middleBreadcrumbs={[{title: "Devenir Partenaire", link: "/espace-pro/devenir-partenaire"}]}
                                  description={"Participer à la création d’une industrie touristique durable."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <SectionTitle title={"Être partenaire de notre Office COTE D’IVOIRE TOURISME est une opportunité à ne pas manquer pour plusieurs raisons."} className={"mt-8"} variant="playfairDisplay" />

              <p className={"text-normal text-justify mt-4"}>
                  C’est la garantie d’une visibilité sur des supports de communication à destination de touristes ivoiriens et internationaux.
                  <br/>
                  <br/>
                  C’est aussi la possibilité de tisser un réseau de professionnels qui se veut apporteur d’affaires pour votre structure.
                  <br/>
                  <br/>
                  Enfin, c’est l’accès à des services plus autour des enjeux juridiques et numériques d’aujourd’hui.
              </p>

              <SectionTitle title={"Comment devenir Partenaire ?"} className={"mt-8"} variant="playfairDisplay" />

              <p className={"text-normal text-justify mt-4"}>
                    Se rapprocher de nos services dédiés aux professionnels, la direction des relations extérieurs et nous allons vous accompagner dans ce processus.
<br/>
<br/>
                  Tout au long de l’année, vous pouvez devenir partenaire de notre Office de tourisme. Pour cela, nous vous invitons à remplir un formulaire correspondant à votre activité et nous le retourner.
<br/>
<br/>
                  N’hésitez pas à nous solliciter pour vous venir en aide. Nous restons disponibles par téléphone, email et au sein de nos bureaux d’information touristique
<br/>
<br/>
                  Un des services dédiés est l’amélioration de la qualité et la mise en conformité
              </p>

          </SectionPage>

        </div>
  );
}
